import { render } from "./SkeletonLoader.vue?vue&type=template&id=f71a90ce&scoped=true"
const script = {}

import "./SkeletonLoader.vue?vue&type=style&index=0&id=f71a90ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f71a90ce"]])

export default __exports__